var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWheat = function SvgIconWheat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    clipPath: "url(#icon-wheat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.021 38.271v-5.625M14.895 20.256l-.645 2.406a7.48 7.48 0 0 0 5.286 9.158q2.242.602 4.485 1.201v-5.16a7.475 7.475 0 0 0-5.514-6.639z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.616 22.746a7.34 7.34 0 0 0 0-10.38L24.02 9.771l-2.595 2.595a7.367 7.367 0 0 0-2.15 5.19 7.34 7.34 0 0 0 2.15 5.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.149 20.256.645 2.406a7.48 7.48 0 0 1-5.288 9.158q-2.243.602-4.485 1.201v-5.16a7.475 7.475 0 0 1 5.515-6.639z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-wheat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6 6h36v36H6z"
  })))));
};
export default SvgIconWheat;